var XPortal = XPortal || {};
XPortal.Redusers = XPortal.Redusers || {};
XPortal.Redusers = (function () {
    const self =
    {
        debug: false,
        _multipleValueSeparator: "_#_",
        ACTIONS: {
            VALIDATION_RESULT: 'VALIDATION_RESULT',
            SAVE_START: 'SAVE_START',
            SAVE_END: 'SAVE_END',
            SAVE_CANCEL: 'SAVE_CANCEL',
            NOTHING_SAVE: 'NOTHING_SAVE',
            ITEM_SAVE_SUCCESS: "ITEM_SAVE_SUCCESS",
            ITEM_REFRESH: "ITEM_REFRESH",
            ITEM_SAVE_FAIL: "ITEM_SAVE_FAIL",
            EDIT_FORM_INITIALIZED: "EDIT_FORM_INITIALIZED",
            GRID_INITIALIZE: "GRID_INITIALIZE",
            GRID_INITIALIZED: "GRID_INITIALIZED",
            GRID_DATALOADED: "GRID_DATALOADED",
            EDITOR_LOADED: "EDITOR_LOADED",
            BIND_ENTITY: "BIND_ENTITY",
            BIND_FIELD: "BIND_FIELD",
            EDIT_FIELD: "EDIT_FIELD",
            EDIT_DISPLAYFIELD: "EDIT_DISPLAYFIELD",
            END_EDIT: "END_EDIT",
            NOTIFY_EDITED: "FIELD_UPDATED_TO",
            DELETED_ENTITY: "DELETED_ENTITY",
            LOADED_ENTITY: "LOADED_ENTITY",
            ADD_MESSAGES: "ADD_MESSAGES",
            SERVER_MESSAGES: "SERVER_MESSAGES",
        }
    };
    const handlers = {};

    self.getModel = function (state, action) {
        var modelName = action.modelName;
        state.pageModels = state.pageModels || {};
        return state.pageModels[modelName] = state.pageModels[modelName] || {};
    };
    var getStackTrace = function () {
        var obj = {};
        Error.captureStackTrace(obj, getStackTrace);
        return obj.stack;
    };
    self.onDebuging = function (state, action, message, ...args) {
        if (!self.debug) return;
        self.counti = self.counti ? self.counti + 1 : 1;
        if (console && console.log) {
            var m = console.log;// : console.error;
            try {
                m("" + self.counti + ". type:" + action.type + " >" + message, {
                    s: Object.assign({}, state), a: Object.assign({}, action), arg: JSON.stringify(args), t: getStackTrace()
                });
            } catch (e) {
                m("" + self.counti + ". type:" + action.type + " >" + message);
            }
        }
    };
    /* --event processors--*/
    function onEditFormInitialized(state, action) {
        self.onDebuging(state, action, "", action.formParameters);
        return Object.assign({}, state, { editParameters: action.formParameters });
    }

    function onGridInitializing(state, action) {
        var newModel = {
            GridModel: action.modelValue,
            model: action.additionalModel
        };
        var modelName = action.model;
        self.onDebuging(state, action, modelName, action.additionalModel);
        state.pageModels = state.pageModels || {};
        state.pageModels[modelName] = state.pageModels[modelName] || {};
        Object.assign(state.pageModels[modelName], newModel);
        return Object.assign(state, { pageModels: state.pageModels });
    }

    function onGridInitialized(state, action) {
        return state;
    }

    function onEditorLoaded(state, action) {
        return state;
    }

    function onEntityBinding(state, action) {
        if (console && self.debug) console.log("Entity binding " + action?.entity?.UniqueId, state, action);

        state.pageModels = state.pageModels || {};
        var currentModel = state.pageModels[action.modelName] || { model: {} };

        var newParams = [{ entity: action.entity }];
        if (action.model) newParams.push({ model: Object.assign(currentModel.model, action.model) });

        var currentModelParams = action.model ? action.model : currentModel.model;
        if (currentModelParams) {
            action.entity.NodeId = currentModelParams.NodeId;
            action.entity.EntityAlias = currentModelParams.Alias;
        }
        currentModel = Object.assign(currentModel, ...newParams);
        state.pageModels[action.modelName] = currentModel;
        self.onDebuging(state, action, action.modelName, action.entity);
        return Object.assign({}, state, { editParameters: state.editParameters, pageModels: state.pageModels });
    }

    function onEntityBinded(state, action) {
        if (console && self.debug) console.log("Entity binded", state, action);
        return Object.assign({}, state, { WasValidated: false, LastRefresh: new Date() });
    }

    function onFieldEditing(state, action) {
        self.onDebuging(state, action, action.modelName, action.model);
        // normalize tz-qualified system datetimes to the member-local naked-ISO frame for every EDIT_FIELD path
        if (action.field) action.field.data = XPortal.Utils.NormalizeSystemDateTime(action.field.data);
        var afname = action.field.field;
        var afdata = action.field.data != null ? String(action.field.data) : null;
        if (!state.pageModels.hasOwnProperty(action.model))
            return state;
        var model = state.pageModels[action.model];
        if (model.model.isViewMode) {
            if (console) console.log("ViewModel - EDIT_FIELDs is not alowed!!!-" + action.model, { action, metadata: model.model });
            return state;
        }
        var isNeedToRefreshGridCell = action.entity && action.entity.uid !== (model.entity && model.entity.uid) || action.forceRefreshCell || action.updateGrid;
        var entity = action.entity ? action.entity : model.entity;
        itemsToSave = model.itemsToSave;

        if (!action.field || !action.field.field) {
            if (console) console.log("Something wrong came to EDIT_FIELD");
            return state;
        }
        //if (entity.hasOwnProperty(action.field.field)) {
        var fieldObjList = entity.Fields.filter(f => f.Name.toLowerCase() === afname);
        var fieldObj = null;
        if (fieldObjList.length < 1) {
            entity.Fields.push({ Name: afname, Type: action.field.ftype });
            fieldObjList = entity.Fields.filter(f => f.Name.toLowerCase() === afname);
        }
        if (fieldObjList.length !== 1) //remove multi-fields
        {
            entity.Fields = entity.Fields.filter(f => f.Name.toLowerCase() !== afname);
            entity.Fields.push(fieldObjList[0]);
            fieldObjList = entity.Fields.filter(f => f.Name.toLowerCase() === afname);
        }
        fieldObj = fieldObjList[0];

        if (fieldObj && compareFieldsVal(fieldObj, afdata, entity[afname]) || (stringifyAndNotEquals(entity[afname], afdata))) {
            if (state.editParameters) //update is changed
                state.editParameters.IsChanged = true;
            fieldObj.StringValue = afdata;
            fieldObj.IsChanged = true;

            if (entity._events && entity.set) { //grid observable 
                var valueToSet = action.field.data;
                if (fieldObj.Type && fieldObj.Type.toLowerCase() === "boolean")
                    valueToSet = action.field.data === "1" ? true : false;
                if (console) console.log("_____Grid item " + (entity?.UniqueId || "").substring(0, 4) + ": " + afname + " set from: " + entity[afname] + " to: " + valueToSet + " model:" + action.model + ".ref?" + isNeedToRefreshGridCell + "|" + action.omitAutoSave);
                entity.set(afname, valueToSet);
                if (isNeedToRefreshGridCell)
                    XPortal.GridInlineEditing.RefreshCell(model, entity, fieldObj, valueToSet);
            } else {
                if (console) console.log("Entity item " + (entity?.UniqueId || "").substring(0, 4) + ": set from: " + entity[afname] + " to: " + action.field.data + ", f:" + afname + ", m:" + action.model);
                entity[afname] = action.field.data;
            }
            if (model && model.model && !action.isDefaultEditor && afname !== "_newrecord") {
                XPortal.Store.SetItemToSave(model, entity, model.model.NodeId, action.updateGrid);
                registerModifedFields(model, afname, afdata, action, state);
            }
        } else {
            if (model.model.IsCreating) {
                var itm = itemsToSave ? itemsToSave.find(i => i.entity.UniqueId === entity.UniqueId) : null;
                if (itm == null) XPortal.Store.SetItemToSave(model, entity, model.model.NodeId, action.updateGrid);
            }
        }
        return Object.assign(state, { editParameters: state.editParameters, pageModels: state.pageModels });
    }
    function dateTimeCutTicks(item) {
        if (!item) return;
        let processVal = item;

        if (typeof processVal.toISOString === 'function') {
            processVal = item.toISOString();
        }
        processVal = processVal.substring(0, processVal.indexOf('.') == -1 ? processVal.length : processVal.indexOf('.'));
        if (processVal.endsWith('Z')) processVal = processVal.slice(0, -1);
        return processVal;
    };
    function compareFieldsVal(fieldObj, checkVal, currentDisplayVal) {
        // For datetimes, compare afdata (always member-local naive) against the field's current member-local value (entity[afname])
        var curNaive = toMemberLocalNaive(currentDisplayVal);
        if (curNaive !== null && XPortal.Utils.IsDateTimeValue(String(checkVal == null ? "" : checkVal)))
            return curNaive != dateTimeCutTicks(checkVal);
        if (fieldObj.Type == 'DateTime')
            return (dateTimeCutTicks(fieldObj.StringValue || "")) != dateTimeCutTicks(checkVal);

        return (fieldObj.StringValue || "") !== (checkVal || "");
    };
    // Current display value as member-local naive YYYY-MM-DDTHH:mm:ss - the same shape afdata is built with, so the same instant compares equal.
    function toMemberLocalNaive(v) {
        if (v == null || v === "") return null;
        if (v instanceof Date) return isNaN(v.getTime()) ? null : XPortal.Utils.FormatDateTimeNaive(v);
        return XPortal.Utils.IsDateTimeValue(String(v)) ? dateTimeCutTicks(String(v)) : null;
    };
    function stringifyAndNotEquals(obj, compareWith) {
        let ires = obj;
        if ((obj === true || obj === false))
            return obj != normalizeStringBoolean(compareWith);
        if (typeof obj == 'number' || typeof obj == 'bigint')
            return obj != normalizeNumber(compareWith);
        if (obj && obj.processed && typeof obj.toISOString === 'function')
            return false; // datetime change is decided by compareFieldsVal against the model StringValue (UTC frame); entity[afname] here is the member-local display Date, so comparing it to afdata would give a false-positive dirty

        if (_.isArray(obj))
            ires = obj.join(self._multipleValueSeparator);
        else if (_.isString(obj))
            ires = obj;
        else if (obj == null) ires = obj;
        else ires = String(obj);

        const res = (ires ?? "") != (compareWith ?? "");
        return res;
    }
    function normalizeStringBoolean(val) {
        if (val == "1" || val == "true" || val == true) return true;
        if (val == "0" || val == "false" || val == false) return false;
        return !(!val);
    }
    function normalizeNumber(val) {
        return Number(val);
    }
    function registerModifedFields(model, afname, afdata, action, state) {
        if (!(model && afname)) return;
        afname = afname.toLowerCase();
        const mfs = model.modifiedFields || (model.modifiedFields = []);
        const ix = _.findIndex(mfs, x => x.field == afname);
        const c = { field: afname, tm: new Date().getTime(), v: afdata };
        if (ix) mfs.splice(ix, 1);
        mfs.push(c);
        XPortal.SectionDisplayRules.updateModel(model, action, state);
        XPortal.AutofillFields.updateModel(model, action, state);
        return c;
    };
    function onDisplayFieldEditing(state, action) {
        self.onDebuging(state, action, action.modelName, action.model);
        if (!state.pageModels.hasOwnProperty(action.model))
            return state;
        var model = state.pageModels[action.model];
        var entity = action.entity ? action.entity : model.entity;

        if (entity._events && entity.set) { //grid observable 
            entity.set(action.field.field, action.field.data);
            XPortal.GridInlineEditing.RefreshCell(model, entity, { Name: action.field.field, Type: action.field.ftype }, action.field.data);
        } else
            entity[action.field.field] = action.field.data;
        return Object.assign(state, { editParameters: state.editParameters, pageModels: state.pageModels });
    }
    function onFieldEdited(state, action) {
        self.onDebuging(state, action, action.modelName, action.model, action.options);
        if (state.pageModels.hasOwnProperty(action.options.model)) {
            model = state.pageModels[action.options.model];
            XPortal.Store.SetItemToSave(model, model.entity);
            return Object.assign(state, { pageModels: state.pageModels });
        }
        return state;
    }
    function onFieldDataRefreshed(state, action) {
        // NOTIFY_EDITED comes after a save reconciled server-changed values; re-evaluate section
        // display rules for them (manual edits get this via onFieldEditing -> registerModifedFields)
        if (action && action.field && action.field.field && action.model && state.pageModels.hasOwnProperty(action.model)) {
            const model = state.pageModels[action.model];
            if (model && model.entity)
                XPortal.SectionDisplayRules.updateModel(model, action, state);
        }
        return state;
    }
    function onValidateResult(state, action) {
        var currentModel = self.getModel(state, action);
        self.onDebuging(state, action, action.modelName, action.model, action.options, currentModel);
        if (state.editParameters) state.editParameters.WasValidated = true; //for now only have indication if form was validated        
        if (currentModel) currentModel.WasValidated = true; //for now only have indication if form was validated
        XPortal.Store.UpdateStatus(currentModel);
        return Object.assign({}, state);
    }

    function onSaving(state, action) {
        var currentModel = self.getModel(state, action);
        self.onDebuging(state, action, action.modelName, action.model, action.options, currentModel);
        if (currentModel) currentModel.SaveInProgress = true;
        XPortal.Store.UpdateStatus(currentModel);
        return Object.assign({}, state);
    }

    function onNoDataToSave(state, action) {
        return state;
    }

    function onSaved(state, action) {
        var currentModel = self.getModel(state, action);
        self.onDebuging(state, action, action.modelName, action.model, action.options, currentModel);
        if (currentModel) currentModel.SaveInProgress = false;
        XPortal.Store.UpdateStatus(currentModel, action.saved);
        return Object.assign({}, state);
    }

    function onSaveCancel(state, action) {
        var model = self.getModel(state, action);
        self.onDebuging(state, action, action.modelName, action.model, action.options, model.model);
        if (!model.itemsToSave) model.itemsToSave = [];
        while (model.itemsToSave.length)
            model.itemsToSave.pop();
        XPortal.Store.UpdateStatus(model);
        return Object.assign({}, state);
    }

    function onItemSuccessfullySaved(state, action) {
        var modelName = action.modelName;
        state.pageModels = state.pageModels || {};
        var currentModel = state.pageModels[modelName];
        self.onDebuging(state, action, action.modelName, action.model, action.options, modelName, currentModel);
        if (currentModel && currentModel.itemsToSave) {
            var ind = currentModel.itemsToSave.findIndex(i => i.entity.UniqueId === action.entity.UniqueId);
            if (ind > -1) {
                var modelItem = currentModel.itemsToSave.splice(ind, 1)[0];
                currentModel.model.IsCreating = modelItem.entity.IsCreating = false;

                var curEntity = modelItem.entity.UniqueId == action.entity.UniqueId ? modelItem.entity : currentModel.itemsToSave.find(i => i.entity.UniqueId === action.entity.UniqueId);
                if (state.editParameters && state.editParameters.NodeId == modelItem.nodeId)
                    state.editParameters.IsCreating = false;
                var savedResultEntity = XPortal.Grid.MapEntity(action.saveResult);
                modelItem.entity = assignModifiedProperties(curEntity, action.entityBefore, savedResultEntity, currentModel);
                modelItem.entity._newrecord = false;

                if (modelItem.entity.hasOwnProperty("_newInlineRecord"))
                    delete modelItem.entity._newInlineRecord;
                modelItem.entity.EntityAlias = currentModel.model.Alias;
                if (modelItem.entity.set) { //refresh grid checks
                    modelItem.entity.dirty = false;
                    modelItem.entity.dirtyFields = {};
                    modelItem.entity.set("dirty", false);
                    $("tr[data-uid='" + modelItem.entity.uid + "']").find(".k-dirty").removeClass("k-dirty"); //DIRTY FIX - when user start edit another record it will be not updated
                }
                XPortal.AutofillFields.updateModel(null, action, state);
            }
        }
        if (state.editParameters)
            state.editParameters.IsChanged = XPortal.Store.IsEntityToSavePresent(state);
        if (currentModel.itemsToSave.length < 1)
            currentModel.SaveInProgress = false;
        if (action.modelName.startsWith("GM.")) {
            var gridSelector = action.modelName.replace("GM.", "");
            if (action.updateGrid) {
                setTimeout(function () {
                    $("#" + gridSelector).data("kendoGrid").dataSource.read();
                }, 1);
            } else {
                XPortal.Grid.Aggregation.RecalculateForGridElement(gridSelector);
            }
        }
        XPortal.Store.UpdateStatus(currentModel, true);
        return Object.assign({}, state, { LastSave: new Date() });
    }
    function onItemRefresh(state, action) {
        var modelName = action.modelName;
        state.pageModels = state.pageModels || {};
        var currentModel = state.pageModels[modelName];
        self.onDebuging(state, action, action.modelName, action.model, action.options, modelName, currentModel);
        if (currentModel && currentModel.entity) {
            var modelItem = currentModel.entity;
            var curEntity = modelItem;
            var savedResultEntity = XPortal.Grid.MapEntity(action.saveResult);
            modelItem.entity = assignModifiedProperties(curEntity, action.entityBefore, savedResultEntity, currentModel);

            modelItem.entity.EntityAlias = currentModel.model.Alias;
            action.entity = null;
            XPortal.AutofillFields.updateModel(null, action, state);
        }
        if (state.editParameters)
            state.editParameters.IsChanged = XPortal.Store.IsEntityToSavePresent(state);
        if (!currentModel.itemsToSave || currentModel.itemsToSave.length < 1)
            currentModel.SaveInProgress = false;

        XPortal.Store.UpdateStatus(currentModel, true);
        return Object.assign({}, state, { LastSave: new Date() });
    }
    // Reconcile server-changed field values (dst.Fields) into the live entity after a save.
    // Skips fields the user edited mid-save; writes directly (no EDIT_FIELD dispatch) so nothing
    // goes dirty / triggers autosave. Changed fields go to itemsToRefresh -> NOTIFY_EDITED.
    function assignModifiedProperties(srcCurrent, srcBefore, dst, currentModel) {
        // grid inline saves pass no "before" snapshot -> they refresh through dataSource.read() instead
        if (!srcBefore || !srcBefore.Fields || !dst || !dst.Fields) return srcCurrent;

        var mobj = { UniqueId: dst.UniqueId };
        var applied = [];   // fields the server changed and we applied to the form
        var keptByUser = []; // fields the server changed but the user edited mid-save -> we kept the user's value
        dst.Fields.forEach(function (serverField) {
            var fname = (serverField.Name || "").toLowerCase();
            if (!fname || fname == "uniqueid" || fname == "updated" || fname == "_newrecord") return;

            // only reconcile fields that were part of the saved entity (present in what we sent)
            var beforeField = srcBefore.Fields.find(function (f) { return f.Name.toLowerCase() == fname; });
            if (!beforeField) return;

            var beforeVal = normalizedFieldValue(beforeField);
            var serverVal = normalizedFieldValue(serverField);
            if (serverVal === beforeVal) return; // server did not change this field

            var currentField = srcCurrent.Fields ? srcCurrent.Fields.find(function (f) { return f.Name.toLowerCase() == fname; }) : null;
            var currentVal = currentField ? normalizedFieldValue(currentField) : beforeVal;
            if (currentVal !== beforeVal) { // user edited it while saving -> keep the user's value
                keptByUser.push({ field: serverField.Name, sent: beforeVal, server: serverVal, kept: currentVal });
                return;
            }

            // dst is already mapped by MapEntity, so it carries both the canonical StringValue and the mapped
            // (display) property; copy both so the live entity stays consistent and won't look dirty later.
            var propName = XPortal.Template.GetObjPropName(dst, fname);
            if (currentField) {
                currentField.StringValue = serverField.StringValue;
                currentField.ismultiselect = serverField.ismultiselect;
                currentField.IsChanged = false;
            } else {
                srcCurrent.Fields.push({ Name: serverField.Name, StringValue: serverField.StringValue, Type: serverField.Type, ismultiselect: serverField.ismultiselect, IsChanged: false });
            }
            var applyValue = dst[propName];
            if (XPortal.Utils.IsDateTimeValue(serverField.StringValue) && dst[propName] instanceof Date && !isNaN(dst[propName].getTime()))
                applyValue = XPortal.Utils.FormatDateTimeNaive(dst[propName]);
            srcCurrent[propName] = applyValue;
            mobj[propName] = applyValue;
            applied.push({ field: serverField.Name, from: beforeVal, to: serverVal });
        });

        var mName = currentModel.model ? currentModel.model.modelName : "";
        if (keptByUser.length && console) console.log("[autofill/save] server changed " + keptByUser.length + " field(s) but the user edited them mid-save - kept user's value on " + mName + ":", keptByUser);

        if (!applied.length) return srcCurrent;

        if (console) console.log("[autofill/save] applied " + applied.length + " server-changed field(s) on " + mName + ": " + applied.map(function (c) { return c.field + " '" + c.from + "' -> '" + c.to + "'"; }).join(", "), applied);

        currentModel.itemsToRefresh = currentModel.itemsToRefresh || [];
        currentModel.itemsToRefresh.push(mobj);
        return srcCurrent;
    }
    // Canonical string form of a field value for change detection. Detects datetimes by value shape
    // (field.Type isn't reliable across snapshots) and strips fraction/Z so equal instants compare equal.
    function normalizedFieldValue(field) {
        if (!field) return "";
        var v = field.StringValue;
        if (Array.isArray(v)) v = v.join(self._multipleValueSeparator);
        v = (v == null) ? "" : String(v);
        if (XPortal.Utils.IsDateTimeValue(v)) v = dateTimeCutTicks(v);
        return v;
    }
    function onItemFailedSaved(state, action) {
        return state;
    }

    function onDeletingEntity(state, action) {
        var deletedItems = state.deletedItems || [];
        XPortal.AutofillFields.updateModel(null, action, state);
        self.onDebuging(state, action, action.modelName, action.model, action.options, deletedItems);
        if (action.entityList) {
            action.entityList.forEach(function (entity) {
                var ind = deletedItems.findIndex(i => i.UniqueId == entity.UniqueId);
                if (ind > -1) deletedItems[ind] = entity;
                else deletedItems.push(entity);
            });
        }
        return Object.assign({}, state, { deletedItems });
    }

    function onAddMessage(state, action) {
        var currentModel = self.getModel(state, action);
        self.onDebuging(state, action, action.modelName, action.model, currentModel);
        if (currentModel) {
            currentModel.messages = currentModel.messages || {};
            Object.assign(currentModel.messages, action.messages);
        }
        return Object.assign({}, state);
    }
    function onServerMessages(state, action) {
        return state;
    }

    function onUnknownAction(state, action, redType) {
        if (action.type.indexOf("@@") != 0)
            self.onDebuging(state, action, action.modelName, action.model, redType);
        return state;
    }

    function reducerFactory(firstState, handlers, tp) {
        return (state = firstState, action) => {
            if (tp == 'unknown') throw 'reducers type is unknown for state' + Json.stringify(Object.assign(state));
            if (tp == 'dr') return state;
            const concrete = handlers[action.type];
            if (!concrete) return onUnknownAction(state, action, tp);
            var result = concrete(state, action);
            if (result) return result;
            return state;
        };
    }
    /* registrations of all known handlers */
    handlers[self.ACTIONS.VALIDATION_RESULT] = onValidateResult;
    handlers[self.ACTIONS.SAVE_START] = onSaving;
    handlers[self.ACTIONS.SAVE_END] = onSaved;
    handlers[self.ACTIONS.SAVE_CANCEL] = onSaveCancel;
    handlers[self.ACTIONS.ADD_MESSAGES] = onAddMessage;
    handlers[self.ACTIONS.NOTHING_SAVE] = onNoDataToSave;
    handlers[self.ACTIONS.ITEM_REFRESH] = onItemRefresh;
    handlers[self.ACTIONS.ITEM_SAVE_SUCCESS] = onItemSuccessfullySaved;
    handlers[self.ACTIONS.ITEM_SAVE_FAIL] = onItemFailedSaved;
    handlers[self.ACTIONS.EDIT_FORM_INITIALIZED] = onEditFormInitialized;
    handlers[self.ACTIONS.GRID_INITIALIZE] = onGridInitializing;
    handlers[self.ACTIONS.GRID_INITIALIZED] = onGridInitialized;
    handlers[self.ACTIONS.EDITOR_LOADED] = onEditorLoaded;
    handlers[self.ACTIONS.BIND_ENTITY] = onEntityBinding;

    handlers[self.ACTIONS.LOADED_ENTITY] = onEntityBinded;
    handlers[self.ACTIONS.EDIT_FIELD] = onFieldEditing;
    handlers[self.ACTIONS.EDIT_DISPLAYFIELD] = onDisplayFieldEditing;
    handlers[self.ACTIONS.NOTIFY_EDITED] = onFieldDataRefreshed;
    handlers[self.ACTIONS.END_EDIT] = onFieldEdited;
    handlers[self.ACTIONS.DELETED_ENTITY] = onDeletingEntity;
    handlers[self.ACTIONS.SERVER_MESSAGES] = onServerMessages;
    self.baseReduser = reducerFactory({ stateType: "base", pageModels: {} }, handlers, 'mr');
    self.deleteReduser = reducerFactory({ stateType: "delt", pageModels: {} }, [], 'dr');
    self.lastActionReducer = (state = null, action) => action;

    return self;
}());
